import styled from "styled-components";

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 290px;
  background-color: ${({ theme }) => theme.bg.atlassian};
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  position: relative;
  padding: 14px;
  overflow: hidden;
`;

export const CardContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const CardHeading = styled.h1`
  margin: 0;
  font-size: 20px;
  color: ${({ theme }) => theme.text.atlassian};
  font-weight: 500;
`;

export const CardParagraph = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.text.atlassian50};
  font-size: 14px;
  line-height: 18px;
  white-space: pre-wrap;
`;

export const CardIllustrationContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
`;

export const CardLabelContainer = styled.div`
  z-index: 2;
`;

export const CardLabel = styled.span`
  background: ${({ background }) => background};
  color: ${({ color }) => color};
  border-radius: 9999px;
  padding: 5px 10px;
  font-size: 12px;
`;

export const CardArrowContainer = styled.div`
  position: absolute;
  top: 16px;
  right: 13px;
`;
